import { motion } from "framer-motion";
import landingImage from "../images/suit.jpg";
import SocialIcons from "./SocialIcons";
import Type from "../components/Home/Type";
import { NavLink } from "react-router-dom";
import Button from "./Button";
import "../components/style.css";

const Hero = ({ name }) => {
  const styles = {
    landingImage: {
      position: "absolute",
      bottom: "0",
      opacity: "0.3",
      mixBlendMode: "lighten",
      height: "80%",
    },
    textContainer: {
      display: "flex",
      flexDirection: "column",
      letterSpacing: "1px",
      textAlign: "center",
      zIndex: "1",
      color: "#fff",
      textShadow: "1px 1px 3px #000",
    },
    name: {
      color: "var(--text-color)",
      fontWeight: "700",
      marginTop: "-100px",
      paddingBottom: "28px",
    },
    buttonContainer: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
      gap: "10px", // Adjust the gap between buttons
      position: "absolute",
      bottom: "66px",
      left: "82%",
      transform: "translateX(-50%)",
      width: "25%", // Adjust the width as needed
      zIndex: 1,
      
    },
    
    button: {
      width: "100%",
    },
  };

  return (
    <>
      <div className="button-container">
        <NavLink to="/portfolio">
          <Button name="VIEW PORTFOLIO" style={styles.button} />
        </NavLink>
        <NavLink to="/Resume">
          <Button name="RESUME" style={styles.button} />
        </NavLink>
      </div>

      <div className="textContainer" style={styles.textContainer}>
        <motion.h1
          className="name"
          style={styles.name}
          initial={{ scale: 0.5, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0, duration: 0.5, type: "spring" }}
        >
          {name}
        </motion.h1>
        <motion.div
          className="description"
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.4, type: "spring" }}
        >
          <Type />
        </motion.div>
      </div>

      <div className="image-container">
        <motion.img
          className="landingImage"
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.25 }}
          transition={{ delay: 1, duration: 1.5, ease: "easeInOut" }}
          style={styles.landingImage}
          src={landingImage}
          alt="Michael Yeates"
        />
      </div>

      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1, ease: "easeInOut" }}>
        <SocialIcons />
      </motion.div>
    </>
  );
};

export default Hero;
